import { mobileDetect } from 'rp-gui-guide';

export const SIRE_LINE = {
    items: [
        {
            caption: 'All',
            value: ''
        },
        {
            caption: 'Return only',
            value: 'include'
        },
        {
            caption: 'Exclude',
            value: 'exclude'
        }
    ],
    name: 'sireLineFlag',
    value: ''
};

const items = [
    {
        caption: 'Weatherbys Stallions',
        captionResponsive: 'Weatherbys',
        iconName: 'weatherby',
        className: 'ui-switcher__btn_weatherbys',
        value: 'weatherbys'
    },
    {
        caption: 'All active',
        value: 'active'
    },
    {
        caption: 'All inactive',
        value: 'inactive'
    }
];

export const STALLION = {
    items,
    name: 'type',
    value: 'weatherbys'
};



// WEBPACK FOOTER //
// ./src/client/optionSets/switchers.js